<template>
    <v-col cols="12" sm="auto" md="auto" style="cursor:pointer;">
        <v-card class="kicker"
                v-scroll-to="'#photo'"
                elevation="4"
                color="blue darken-4"
                dark>
            <div style="float:right;" class="ma-0 mt-2 mr-1">
                <span v-if="!HasCompletedAnyRegistrations && !HasRegisteredOrCurrentEnrolments"
                      class="fa-stack fa-lg">
                    <i class="fas fa-circle fa-stack-2x icon-info"></i>
                    <i class="fas fa-info fa-stack-1x"></i>
                </span>
                <span v-else-if="PhotoVerified"
                      class="fa-stack fa-lg">
                    <i class="fas fa-circle fa-stack-2x icon-success"></i>
                    <i class="fas fa-check fa-stack-1x"></i>
                </span>
                <span v-else-if="!PhotoUploaded"
                      class="fa-stack fa-lg">
                    <i class="fas fa-circle fa-stack-2x icon-error"></i>
                    <i class="fas fa-exclamation fa-stack-1x"></i>
                </span>
                <span v-else-if="PhotoOutdated || PhotoRejected"
                      class="fa-stack fa-lg">
                    <i class="fas fa-circle fa-stack-2x icon-error"></i>
                    <i class="fas fa-exclamation fa-stack-1x"></i>
                </span>
                <span v-else-if="!PhotoVerified"
                      class="fa-stack fa-lg">
                    <i class="fas fa-circle fa-stack-2x icon-info"></i>
                    <i class="far fa-clock fa-stack-1x"></i>
                </span>
            </div>
            <v-card-title>Your Photo</v-card-title>
            <v-card-text>
                <p v-if="!HasCompletedAnyRegistrations && !HasRegisteredOrCurrentEnrolments" class="ma-0">Complete your registration to upload a photo</p>
                <p v-else-if="PhotoVerified" class="ma-0">Your photo has been approved</p>
                <p v-else-if="!PhotoUploaded" class="ma-0">Submit a photo for your College Card</p>
                <p v-else-if="PhotoOutdated" class="ma-0">You need a new photo for this year</p>
                <p v-else-if="PhotoRejected" class="ma-0">Your photo has been rejected</p>
                <p v-else-if="!PhotoVerified" class="ma-0">Your photo is being processed</p>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
    import moment from 'moment'

    import ctrlOpenMixin from '@/views/components/mixins/base/ctrlOpen.js'
    import enrolmentsMixin from '@/views/components/mixins/enterpriseDataApi/enrolments.js'
    import enrolmentRegistrationsMixin from '@/views/components/mixins/enrolmentRegistrations.js'
    import photosMixin from '@/views/components/mixins/photos.js'

    export default {
        props: ['localSettings', 'enrolmentRegistrations', 'photoRecord', 'photo', 'enrolments'],
        mixins: [
            ctrlOpenMixin,
            enrolmentsMixin,
            enrolmentRegistrationsMixin,
            photosMixin,
        ],
        computed: {
            PhotoUploadLimitDate() { return moment(this.localSettings?.keyValuePairs?.PhotoUploadLimitDate); },
            PhotoOutdated() { return this.PhotoVerified && moment(this.photo.lastUpdated).isBefore(this.PhotoUploadLimitDate); },
            CanUploadPhoto() { return moment().isBefore(this.PhotoUploadLimitDate); },
        },
        methods: {
            GoToHelpPoint() { this.CtrlOpen(`/here-to-help`); },
            GoToGuidance() { this.CtrlOpen(`/photo-guidance`); },
        },
    }
</script>